import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import DashboardHeader from 'components/DashboardHeader/styles';
import Headline from 'components/Headline/styles';
import ByocProgressBar from 'components/ByocProgressBar';
import DashboardContent from 'components/DashboardContent/styles';
import {
  SignUpContainer,
  SignUpSuccessImg,
  SignUpText,
  SignUpTitle
} from 'routes/App/byocOnboarding/SignUp/styles';
import ImgSignUpSuccess from 'assets/selfDelivery/sign_up_success.svg';
import DialogAction from 'components/DialogAction/styles';
import {ButtonPrimary} from 'components/buttons';
import DialogActions from 'components/DialogActions/styles';
import {PROGRESS_BAR_STEPS} from 'helpers/constants/byocOnboarding';

const SignUpSuccess = () => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <DashboardContent className='DashboardContent'>
      <DashboardHeader>
        <Headline className='mTop5'>Self Delivery</Headline>
      </DashboardHeader>
      <ByocProgressBar currentStep={2} steps={PROGRESS_BAR_STEPS} />
      <SignUpContainer>
        <SignUpTitle>Sign Up Successful!</SignUpTitle>
        <SignUpText className='mTop16'>
          Your plan has been confirmed. Let&apos;s continue with the setup
          process.
        </SignUpText>
        <SignUpSuccessImg>
          <img src={ImgSignUpSuccess} alt='Success' />
        </SignUpSuccessImg>
        <DialogActions className='justifyEnd'>
          <DialogAction className='w30'>
            <ButtonPrimary
              onClick={() => history.push('/byoc-onboarding/menu-setup')}
              type='button'
            >
              <span>Continue</span>
            </ButtonPrimary>
          </DialogAction>
        </DialogActions>
      </SignUpContainer>
    </DashboardContent>
  );
};

export default SignUpSuccess;
